class MinerwaReveal extends HTMLElement {
  connectedCallback() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        this.dataset.revealed = 'true';
        this.observer.disconnect();
      },
      { rootMargin: '-80px' },
    );
    this.observer.observe(this);

    this.videos = [...this.querySelectorAll('[data-showroom-video]')];
    if (this.videos.length > 0) {
      this.videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting) {
              if (video.preload !== 'auto') {
                video.preload = 'auto';
                video.load();
              }
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.2 },
      );
      this.videos.forEach((v) => this.videoObserver.observe(v));
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.videoObserver?.disconnect();
  }
}

['minerwa-about-story', 'minerwa-pillars', 'minerwa-showrooms'].forEach((name) => {
  if (!customElements.get(name)) customElements.define(name, class extends MinerwaReveal {});
});
